import type { Socket } from "socket.io-client";
import { EVENT_TYPE } from "~/constants";
import useEventStore from "~/stores/event";
import useUserStore from "~/stores/user";
import { SOCKET_EVENT, SOCKET_IO_EVENT } from "./index";

export default function useUserSocket(socket: Socket) {
  const userStore = useUserStore();
  const route = useRoute();
  const eventStore = useEventStore();

  socket.on(SOCKET_IO_EVENT.CONNECT, onSocketConnect);

  // handle user clip updates
  socket.on(SOCKET_EVENT.USER_CLIP_UPDATED, async (payload: { clipId: string; eventId: string }) => {
    // if user is on the event page that matches the eventId then reload user clips for this event
    const currentEventId = route.params.eventId as string;
    if (currentEventId && currentEventId === payload.eventId) {
      const updatedClips = await eventStore.loadUserMedia(payload.eventId, EVENT_TYPE.USER_CLIP);
      eventStore.userClips = updatedClips;
    }
  });

  watch(
    () => userStore.user,
    (user, oldUser) => {
      if (user)
        joinUser(user);
      else if (oldUser)
        leaveUser(oldUser);
    },
  );

  // Handle race condition: if socket is already connected, join immediately
  if (socket.connected) {
    onSocketConnect();
  }

  function onSocketConnect() {
    userStore.user && joinUser(userStore.user);
  }

  function joinUser(user: IModelUser) {
    const payload = { userId: user.id };
    // TODO: Remove logging in future
    // eslint-disable-next-line no-console
    const onMessageResponse = (response: any) => console.log("user joined socket room", JSON.parse(response));

    socket.emit(SOCKET_EVENT.JOIN_USER_ROOM, payload, onMessageResponse);
  }

  function leaveUser(user: IModelUser) {
    const payload = { userId: user.id };
    // eslint-disable-next-line no-console
    const onMessageResponse = (response: any) => console.log("user left socket room", JSON.parse(response));

    socket.emit(SOCKET_EVENT.LEAVE_USER_ROOM, payload, onMessageResponse);
  }
}
